var endings = [
    ', most likely',
    ', probably',
    ', definitely',
    ', for sure',
    ', fr fr',
    ', allegedly',
    ', supposedly',
];
export var geniusData = [
    {
        quote: 'Bulls... bears...it’s all relative, man',
        quoteBy: 'Einstein' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava1.png',
    },
    {
        quote: 'Crypto is more important than Gravity',
        quoteBy: 'Newton' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava2.png',
    },
    {
        quote: 'Dog coins > fundamental physics',
        quoteBy: 'Tesla' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava4.png',
    },
    {
        quote: 'The  trenches are f***king brutal ',
        quoteBy: 'Sun Tzu' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava5.png',
    },
    {
        quote: 'PVP Environment...best be enlightened son',
        quoteBy: 'Plato' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava3.png',
    },
    {
        quote: 'E = MC² is cool, but have you seen these gains?',
        quoteBy: 'Einstein' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava1.png',
    },
    {
        quote: 'The half-life of these shitcoins is remarkably brief',
        quoteBy: 'Marie Curie' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava12.png',
    },
    {
        quote: 'For every pump, there is an equal and opposite dump',
        quoteBy: 'Newton' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava2.png',
    },
    {
        quote: 'I refuse to move from this position until my take profit hits',
        quoteBy: 'Rosa Parks' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava36.png',
    },
    {
        quote: 'The art of trading is fought with psychological warfare',
        quoteBy: 'Sun Tzu' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava5.png',
    },
    {
        quote: 'I heard voices telling me to buy the dip',
        quoteBy: 'Joan of Arc' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava28.png',
    },
    {
        quote: "I'm feeling good about this bull market",
        quoteBy: 'Nina Simone' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava24.png',
    },
    {
        quote: "To the moon? I've flown higher",
        quoteBy: 'Amelia Earhart' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava26.png',
    },
    {
        quote: 'God is dead, but crypto is eternal',
        quoteBy: 'Nietzsche' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava7.png',
    },
    {
        quote: 'One is not born, but becomes a degen',
        quoteBy: 'Simone de Beauvoir' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava23.png',
    },
    {
        quote: 'And still my portfolio rises',
        quoteBy: 'Maya Angelou' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava29.png',
    },
    {
        quote: 'It is a truth universally acknowledged that a trader must be in want of gains',
        quoteBy: 'Jane Austen' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava30.png',
    },
    {
        quote: 'HODL and be strong',
        quoteBy: 'Hemingway' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava13.png',
    },
    {
        quote: 'Because I could not stop for FUD, it kindly stopped for me',
        quoteBy: 'Emily Dickinson' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava33.png',
    },
    {
        quote: "I have created a monster... it's called my portfolio",
        quoteBy: 'Mary Shelley' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava35.png',
    },
    {
        quote: 'Natural selection will sort out the weak hands',
        quoteBy: 'Darwin' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava15.png',
    },
    {
        quote: 'The problem of the 21st century is the problem of the paper hands',
        quoteBy: 'W.E.B. Du Bois' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava32.png',
    },
    {
        quote: 'I came, I saw, I aped in',
        quoteBy: 'Alexander the Great' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava34.png',
    },
    {
        quote: 'I cannot tell a lie... these gains are unreal',
        quoteBy: 'George Washington' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava38.png',
    },
    {
        quote: 'Not all who retreat from the market are lost',
        quoteBy: 'Napoleon' + endings[Math.floor(Math.random() * endings.length)],
        image: 'ava39.png',
    },
];
